import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { defaultTo } from 'lodash-es';
import type { AufgabeQuery } from './__generated__/aufgabe';

export type { AufgabeFragment as Aufgabe } from './__generated__/aufgabe';

export const useAufgabe = (aufgabenId: string, skip = false) => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();

  const { loading, data } = useQuery<AufgabeQuery>(gql`
    query Aufgabe($id: UUID!) {
      aufgabe(id: $id) {
        ...Aufgabe
      }
    }
    fragment Aufgabe on Aufgabe {
        id
        beschreibung
        details
        ergebnis
        ergebnisOption
        kommentar
        kampagne
        status
        teilnehmerId
        titel
        typ
        umfrageId
        objekt {
          id
          name
          adressId
        }
        protokoll {
          erstellt
          akteur
        }
        erfolgloseAntworten
        erfolgreicheAntworten
        ungewisseAntworten
      }
  `, {
    skip: skip,
    variables: { id: aufgabenId },
    fetchPolicy: 'cache-and-network',
    onError: e => {
      return handleWithErrorNotification('Aufgabe konnte nicht geladen werden.');
    },
  });

  return {
    loading,
    aufgabe: defaultTo(data?.aufgabe, null),
  };
};
